import React from 'react'
import AssignmentMenuItem from './AssignmentMenuItem'

export default ({ pendingNotificationCount, onQueueNotificationCount }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <AssignmentMenuItem to="/assignment/staff" title="STAFF" />
      <AssignmentMenuItem
        to="/assignment/pending"
        title="PENDING"
        notificationCount={pendingNotificationCount}
      />
      <AssignmentMenuItem
        to="/assignment/on-queue"
        title="ON QUEUE"
        notificationCount={onQueueNotificationCount}
      />
    </div>
  )
}
